'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagSrAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M1.63317e-05 -7.62939e-06L28 -2.21282e-06C28 6.66667 28 13.3333 28 20H0C1.55319e-05 13.3333 -8.97284e-05 6.66666 1.63317e-05 -7.62939e-06Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.08616e-06 4H28V-2.21282e-06L1.63317e-05 -7.62939e-06L2.08616e-06 4Z",
          fill: "#43924C"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 20H28V16H2.08616e-06L0 20Z",
          fill: "#43924C"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.08616e-06 13.3333H28V6.66667H2.08616e-06V13.3333Z",
          fill: "#CD153A"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.9998 11.7L12.0406 13.0301L12.7001 10.7557L10.8296 9.30327L13.1965 9.22767L13.9998 7L14.8031 9.22767L17.17 9.30327L15.2996 10.7557L15.9591 13.0301L13.9998 11.7Z",
          fill: "#F5D24B"
        }
      )
    ]
  }
);
const VpFlagSrAsset = forwardRef(FlagSrAsset);

export { VpFlagSrAsset as default };
